module.exports = {"130708001":"孔家庄街道","130708100":"孔家庄镇","130708101":"万全镇","130708102":"洗马林镇","130708103":"郭磊庄镇","130708200":"膳房堡乡","130708201":"北新屯乡","130708202":"宣平堡乡","130708203":"高庙堡乡","130708204":"旧堡乡","130708205":"安家堡乡","130708206":"北沙城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130708.json
// module id = 182
// module chunks = 0